import { render, staticRenderFns } from "./ListarPersonas.vue?vue&type=template&id=7d087c51&"
import script from "./ListarPersonas.vue?vue&type=script&lang=js&"
export * from "./ListarPersonas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports